export default {"src":"/_next/static/media/userOrange.cc5fd2d4.svg","height":14,"width":14};